export default __webpack_public_path__ + "static/media/profile7.ed1cb5bd.png";